import classnames from "classnames";
import type { ReactNode } from "react";

interface FooterProps {
  children?: ReactNode;
  className?: string;
}

export const Footer = ({ className, children }: FooterProps) => (
  <div
    className={classnames(
      "border-primary sticky border-t p-5 md:px-6 md:py-4",
      className,
    )}
  >
    <div className="mx-auto flex w-full max-w-[45rem] items-center justify-between">
      {children}
    </div>
  </div>
);
